import React, { useEffect, useState } from 'react';
import Button from '@legacy-vfuk/core-button';
import {
  GoalsQuestionsProps,
  ItemTypes,
  SubQuestionsResponseTypes,
} from '../../types/GoalsQuestionsTypes';
import Heading from '@legacy-vfuk/core-heading';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import { NextButtonWrapper } from '../../styles/GoalsQuestions.styles';
import YesNoButtonsList from './YesNoButtonsList';
import YesNoButtons from './YesNoButtons';
import fireAssessmentCommonEvents from '../../../../../../helpers/fireAssessmentCommonEvents';

const GoalsQuestions = ({
  content,
  qnum,
  item,
  twinPairQuestionsArray,
  goalsSecPropFunction,
  nextBusinessEvent,
  updateGoalsResponse,
  relatedAnswer,
  setNextButtonDisabled,
  nextButtonDisabled,
}: GoalsQuestionsProps) => {
  const [showRelatedQuestions, setShowRelatedQuestions] = useState<ItemTypes[]>(
    []
  );
  const [subQuestionsResponse, setSubQuestionsResponse] = useState<
    SubQuestionsResponseTypes[]
  >([]);
  const [mainQuestionIq, setMainQuestionId] = useState<string>('');
  const [mainQuestionExternalId, setMainQuestionExternalId] =
    useState<string>('');
  const [mainQuestionResponse, setMainQuestionResponse] = useState<string>('');
  const [outLineMsg, setOutLineMsg] = useState([]);

  const getRelatedQuestions = (
    e: any,
    item: any,
    index: number,
    answer: any
  ) => {
    //When users click on No Button of initial Question in BusinessGoalsSection,
    //setOutLineMsg will be set to empty, which help to logic to make Red-Alert message Disable.
    if (index === 1) {
      setOutLineMsg([]);
    }
    setMainQuestionId(item.id);
    setMainQuestionExternalId(item.externalId);
    setMainQuestionResponse(answer);

    // Added the below if statment because DXL is not passing the object in the new spec
    // Once DXL rectify this issue the below if statment can be removed.
    if (!item.hasOwnProperty('relatedQuestion')) {
      Object.assign(item, { relatedQuestion: [] });
    }

    const results = item.relatedQuestion.filter((obj: any) => {
      const targetValue =
        e.target.id === 'main-qes_' + item.id + '_' + 'no' ? 'No' : 'Yes';
      return obj.relationship.criteriaValue.toString().includes(targetValue);
    });

    const element: any =
      index === 0
        ? document.getElementById('main-qes_' + item.id + '_' + 'no')
        : document.getElementById('main-qes_' + item.id + '_' + 'yes');
    element.classList.remove('active');
    e.target.classList.add('active');

    setShowRelatedQuestions(results);
    if (results.length === 0) {
      updateGoalsResponse(item.id, item.externalId, answer);
      setNextButtonDisabled(false);
      setSubQuestionsResponse([]);
    } else {
      updateGoalsResponse(item.id, item.externalId, answer);
      setNextButtonDisabled(true);
    }
    fireAssessmentCommonEvents(e.target.innerHTML);
  };

  const createSecondSetAnswerAPI = async (
    e: any,
    item: any,
    index: any,
    answer: any
  ) => {
    const temp = [...outLineMsg, item.externalId];
    setOutLineMsg(temp);

    const relatedAnswers = {
      externalId: item.externalId,
      question: {
        id: item.question.id,
        response: {
          responseText: [answer],
        },
      },
    };

    const checkAlreadySelected = subQuestionsResponse.findIndex(
      (obj: any) => obj.externalId.toString() === item.externalId.toString()
    );

    await setSubQuestionsResponse(
      checkAlreadySelected === -1
        ? (subQuestionsResponse: any) => [
            ...subQuestionsResponse,
            relatedAnswers,
          ]
        : subQuestionsResponse.map((obj: any) => {
            return obj.externalId === item.externalId ? relatedAnswers : obj;
          })
    );

    const element: any =
      index === 0
        ? document.getElementById(item.question.id + '_' + 'no')
        : document.getElementById(item.question.id + '_' + 'yes');
    element.classList.remove('active');
    e.target.classList.add('active');

    updateGoalsResponse(
      mainQuestionIq,
      mainQuestionExternalId,
      mainQuestionResponse,
      relatedAnswers
    );
    fireAssessmentCommonEvents(e.target.innerHTML);
  };

  useEffect(() => {
    if (
      showRelatedQuestions.length > 0 &&
      subQuestionsResponse.length === showRelatedQuestions.length
    ) {
      setNextButtonDisabled(false);
    }
  }, [subQuestionsResponse]);

  useEffect(() => {
    if (nextButtonDisabled) {
      goalsSecPropFunction(qnum + 1, '');
    } else {
      goalsSecPropFunction(qnum + 1, 'enable');
    }
  }, [nextButtonDisabled]);

  const getQuestionImage = (quesNum: number) => {
    const questionImages =
      content?.surveyQuestionsImage?.questionImages[quesNum]?.file?.url;
    const defaultImages =
      content?.surveyQuestionsImage?.defaultImage?.file?.url;
    return questionImages === undefined || questionImages === null
      ? defaultImages
      : questionImages;
  };

  return (
    <div
      id="carouselItem"
      className={`question${qnum + 1} list-of-quest-main-div`}
    >
      <img className="sureyQueImage" src={getQuestionImage(qnum)} />
      <div className="questionStyle">{`${content.questionNumberText1} ${
        qnum + 1
      } ${content.questionNumberText2} ${
        twinPairQuestionsArray.item.question.length
      }`}</div>
      <Heading weight={2} size={3}>
        {item.questionText}
      </Heading>
      <div className="asses-helper-text">{content.headingText[6]}</div>

      {nextButtonDisabled && showRelatedQuestions.length > 0 && (
        <div className="warningMsg">
          Please answer all the questions to continue{' '}
        </div>
      )}

      {/* Initial yes/no assessment question */}
      <YesNoButtons
        keyPrefix={qnum.toString()}
        item={item}
        onClickHandler={getRelatedQuestions}
      />

      {/*Assessment business goals related questions */}
      {showRelatedQuestions.length > 0 &&
        showRelatedQuestions.map((relatedQuestion: any, rqnum: number) => (
          <React.Fragment key={rqnum}>
            <YesNoButtonsList
              keyPrefix={rqnum.toString()}
              onClickHandler={createSecondSetAnswerAPI}
              relatedQuestion={relatedQuestion}
            />
          </React.Fragment>
        ))}

      {nextButtonDisabled && showRelatedQuestions.length > 0 && (
        <div className="warningMsg">
          Please answer all the above questions to continue
        </div>
      )}
      {/*Next Button*/}
      <SimpleGrid justify="center">
        <NextButtonWrapper className="business-goals-next-btn">
          <Button
            id={`bgnt-${qnum + 1}`}
            text={content.nextButton.label}
            appearance="primary"
            onClick={() => {
              nextBusinessEvent(relatedAnswer, qnum);
            }}
            state={nextButtonDisabled ? 'disabled' : undefined}
          />
        </NextButtonWrapper>
      </SimpleGrid>
    </div>
  );
};

export default GoalsQuestions;
